<template>
    <v-content class="bg-content">
        <v-container fluid grid-list-xl style="margin-top: -50px;">
            <User />
        </v-container>
        <v-container fluid grid-list-xl style="max-width: 96%; padding: 12px; margin-top: -500px;">
          <sequential-entrance fromBottom>
            <v-layout row wrap>
              <sequential-entrance fromBottom delay="2000">
                  <v-container fluid>
                    <v-layout row wrap>

                      <div v-for="(item, index) in dailyBreif" :key="item.message" style="flex: 1; margin: 10px;">
                        <v-card
                          class="theme-bg-card"
                          v-bind:class="{
                            'theme-bg-card-active': brefingIndex - 1 == index,
                          }"
                          style="height: 240px; text-align: center;"
                        >
                          <v-list-item>
                            <sequential-entrance delay="2500" fromTop>
                              <v-list-item-content>
                                <v-flex class="space4"></v-flex>
                                <div class="overline text-center" style="color: #fff text-align: center">
                                <v-icon x-large color="blue darken-2">
                                  {{ item.icon }}
                                </v-icon>
                              </div>
                                <v-flex class="space4"></v-flex>
                                <div class="text-center" >
                                  <h5 class="font">{{ item.label }}</h5>
                                </div>

                                <div style="color: #78b59c; text-align: center">
                                  {{ item.message }}
                                </div>
                                <v-flex class="space4"></v-flex>
                              </v-list-item-content>
                            </sequential-entrance>
                          </v-list-item>
                        </v-card>
                      </div>
                    </v-layout>
                  </v-container>
              </sequential-entrance>
            </v-layout>
          </sequential-entrance>
        </v-container>


        <v-container fluid grid-list-xl style="max-width: 100%; top: 20px;">
          <sequential-entrance fromBottom>
            <v-layout row wrap fluid>
              <sequential-entrance fromBottom delay="2000">
                  <v-container fluid grid-list-xl>
                    <v-layout fluid row wrap>
             <v-flex sm4 xs4 md2 lg2>
            <v-btn
              href="/interface"
              class="theme-bg-card-2"
              outlined
            >
              <v-avatar size="60">
                    <img src="@/assets/InterfaceIcon2.png">
             </v-avatar>  
            <!-- <div class="nav-title">Interface</div>         -->
            </v-btn>
            </v-flex>
             <v-flex sm4 xs4 md2 lg2>
            <v-btn
              href="/dashboard"
              class="theme-bg-card-2"
              outlined
            >
              <v-avatar size="60">
                   <img src="@/assets/InterfaceIcon.png">
              </v-avatar>

            <!-- <div class="nav-title">Dashboard</div> -->
            </v-btn>
            </v-flex>
            <v-flex sm4 xs2 md2 lg2>
            <v-btn
              href="/tasks"
              class="theme-bg-card-2"
              outlined
            >
              <v-avatar size="60">
                   <img src="@/assets/TaskIcon.png">
              </v-avatar> 
            <!-- <div class="nav-title">Task</div> -->
            </v-btn>
            </v-flex>
             <v-flex sm4 xs4 md2 lg2>
            <v-btn
              href="/invoices"
              class="theme-bg-card-2"
              outlined
            >
              <v-avatar size="60">
                   <img src="@/assets/InvoiceIconNEW3.png">
              </v-avatar>
            <!-- <div class="nav-title">Sale</div> -->
            </v-btn>
            </v-flex>
             <v-flex sm4 xs4 md2 lg2>
            <v-btn
              href="/calendar"
              class="theme-bg-card-2"
              outlined
            >
              <v-avatar size="60">
                   <img src="@/assets/CalendarIcon.png">
              </v-avatar>
            <!-- <div class="nav-title">Calendar</div> -->
            </v-btn>
            </v-flex>
             <v-flex sm4 xs4 md2 lg2>
            <v-btn
              href="/chat"
              class="theme-bg-card-2"
              outlined
            >
              <v-avatar size="60">
                   <img src="@/assets/ChatIcon.png">
              </v-avatar>
            <!-- <div class="nav-title">Chat</div> -->
            </v-btn>
            </v-flex>
          
    <!-- <v-btn value="recent">
      <span>Recent</span>
      <v-icon>mdi-history</v-icon>
    </v-btn>
    <v-btn value="favorites">
      <span>Favorites</span>
      <v-icon>mdi-heart</v-icon>
    </v-btn>
    <v-btn value="nearby">
      <span>Nearby</span>
      <v-icon>mdi-map-marker</v-icon>
    </v-btn> -->
                <v-flex class="space5"></v-flex>
                    </v-layout>
                  </v-container>
              </sequential-entrance>
            </v-layout>
          </sequential-entrance>
        </v-container>



        <v-overlay :value="overlay" opacity="0.99" z-index="9">
          <!-- <v-btn class="mx-2 close-btn" fab dark small color="#ccc" @click="overlay = false">X</v-btn> -->
          <v-card v-scroll.self="onScroll">
            <CommandAssistantDashboard v-if="type == 'commands'" />
            <Calendar v-if="type == 'calendar'" />
            <Email v-if="type == 'email'" />
            <VideoPlayer v-if="type == 'mix'" />
            <VideoPlayerTwo v-if="type == 'night'" />
            <VideoPlayerThree v-if="type == 'chill'" />
            <VideoPlayerFour v-if="type == 'smooth'" />
            <VideoPlayerFive v-if="type == 'cyber'" />
          </v-card>
        </v-overlay>
    </v-content>
</template>

<script>
import CommandAssistantDashboard from '../components/CommandAssistantDashboardDev.vue';
import Calendar from './../components/Calendar.vue';
import VideoPlayer from './../components/VideoPlayer.vue';
import VideoPlayerTwo from './../components/VideoPlayerTwo.vue';
import VideoPlayerThree from './../components/VideoPlayerThree.vue';
import VideoPlayerFour from './../components/VideoPlayerFour.vue';
import VideoPlayerFive from './../components/VideoPlayerFive.vue';
import Email from './../components/Email.vue';
import { gmapApi } from 'vue2-google-maps';
import User from '../components/User.vue';
import startAudio from '@/assets/audio/Hud.wav';

export default {
  name: 'Dashboard',
  data: () => ({
    dashboard: {},
    value: 'recent',
    speech: new SpeechSynthesisUtterance(),
    overlay: false,
    type: '',
    productDetails: true,
    brefingIndex: 1,
    absolute: true,
    title: '',
    google: gmapApi,
    date: new Date().toDateString(),
    position: '',
    item: 1,
    selectedItem: 1,
    menu: false,
    userInfo: {},
    usersList: [],
    dailyBreif: [
      {
        label: 'DATE',
        message: new Date().toDateString().toLocaleUpperCase(),
        icon: 'mdi-calendar-today',
      },
      {
        label: 'CALENDAR',
        message: 'PENDING',
        icon: 'mdi-calendar-check',
      },
      {
        label: 'TASK',
        message: 'PENDING',
        icon: 'mdi-check-outline',
      },
      {
        label: 'INVOICES',
        message: 'PENDING',
        icon: 'mdi-file',
      },
      {
        label: 'CALLS',
        message: '5 TEAM CALLS',
        icon: 'mdi-phone',
      },
      {
        label: 'MEETINGS',
        message: '11:00 AM TEAM',
        icon: 'mdi-account-group',
      },
      {
        label: 'EMAILS',
        message: 'PENDING',
        icon: 'mdi-email-outline',
      },
    ],
  }),
  components: {
    CommandAssistantDashboard,
    Calendar,
    Email,
    VideoPlayer,
    VideoPlayerTwo,
    VideoPlayerThree,
    VideoPlayerFour,
    VideoPlayerFive,
    User,
  },
  computed: {},
  methods: {
    getDashboard: async function() {
      const voiceName = 'Google UK English Male';
      this.speech.volume = 1;
      this.speech.rate = 1;
      this.speech.pitch = 1;
      this.speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      this.speech.text = 'Accessing your data, please authorize connection';
      window.speechSynthesis.speak(this.speech);
      window.gapi.load('client', this.initializeGapiClient);
      new Audio(startAudio).play();
      Event.$on('stop', () => {
        this.speech.stop();
      });
    },
    next: () => {
      this.$refs.slick.next();
    },
    prev: () => {
      this.$refs.slick.prev();
    },
    reInit: () => {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick();
    },
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);

      speech.onend = function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 4000);
     };
    },
    async initializeGapiClient() {
      console.log('Init Google Client');
      await window.gapi.client.init({
        apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest', 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
      });
      let tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: 'https://mail.google.com/',
        callback: '', // defined later
      });
      tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
          throw resp;
        }
        this.listMessages();
        this.getTasksList();
        // this.getEvents();
        // this.getUserInfo();
        this.getInvoicesList();
      };
      if (window.gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({ prompt: '' });
      }
    },
    listMessages() {
      window.gapi.client.gmail.users.messages
        .list({
          userId: 'me',
          id: 'IMPORTANT',
          labelIds: 'UNREAD',
        })
        .then((response) => {
          console.log('List Message', response.result);
          //Length of all important unread emails
          this.dailyBreif[6].message = `${response.result.resultSizeEstimate}` + ' PRIORITY';
          // this.unreadMail();
          setTimeout(() => this.getEvents(), 0);
        });
    },
    nav(path) {
      this.$router.push({ name: path });
    },
    startBrefing() {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 0.90;
      speech.pitch = 1;
      speech.lang = 'en-GB';
      speech.text = `From ${this.dailyBreif[this.brefingIndex].label}, you have ${this.dailyBreif[this.brefingIndex].message}`;
      window.speechSynthesis.speak(speech);
      this.brefingIndex = this.brefingIndex + 1;
      let self = this;
      speech.onend = function(event) {
        console.log(event);
        console.log(self.brefingIndex + '--' + self.dailyBreif.length);
        if (self.brefingIndex < self.dailyBreif.length) {
          self.startBrefing();
        } else {
          this.brefingIndex = 0;
        }
      };
    },
    getEvents() {
      //for getting calendar events
      let tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/calendar.readonly',
        callback: '', // defined later
      });
      tokenClient.callback = async (resp) => {
        if (resp.error !== undefined) {
          throw resp;
        }
        window.gapi.client.calendar.events
          .list({
            calendarId: 'primary',
            // timeMin: new Date(2019, 1, 1).toISOString(),
            timeMin: new Date().toISOString(),
            showDeleted: false,
            singleEvents: true,
            maxResults: 10,
            orderBy: 'startTime',
          })
          .then((response) => {
            this.items = response.result.items;
            this.speech.text = 'Imported relevant data...... say start briefing when ready.';
            window.speechSynthesis.speak(this.speech);
            this.dailyBreif[1].message = `${this.items.length} ` + 'EVENTS';
            console.log(this.items);
          });
      };
      if (window.gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        tokenClient.requestAccessToken({ prompt: '' });
      }
    },
    getTasksList: async function() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}task-form/all`);
      const json = await response.json();
      console.log(json.result);
      this.dailyBreif[2].message = `${json.result.length} ` + ' PENDING';
    },
    getInvoicesList: async function() {
      const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}invoice-form/all`);
      const json = await response.json();
      console.log(json.result);
      this.dailyBreif[3].message = `${json.result.length} ` + ' INVOICES';
    },
  },
  mounted() {
    this.getDashboard();
    Event.$on('showCard', (data) => {
      console.log(data);
      if (data.msg.indexOf('calendar') != -1) {
        this.type = 'calendar';
      }
      this.overlay = true;
    });
    Event.$on('showEmail', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('email') != -1) {
        this.type = 'email';
      }
      this.overlay = true;
    });
    Event.$on('showCommands', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('commands') != -1) {
        this.type = 'commands';
      }
      this.overlay = true;
    });
    Event.$on('playMix', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('mix') != -1) {
        this.type = 'mix';
      }
      this.overlay = true;
    });
    Event.$on('playNight', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('night') != -1) {
        this.type = 'night';
      }
      this.overlay = true;
    });
    Event.$on('playChill', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('chill') != -1) {
        this.type = 'chill';
      }
      this.overlay = true;
    });
    Event.$on('playSmooth', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('smooth') != -1) {
        this.type = 'smooth';
      }
      this.overlay = true;
    });
    Event.$on('playCyber', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('cyber') != -1) {
        this.type = 'cyber';
      }
      this.overlay = true;
    });
    Event.$on('closeCard', (data) => {
      if (this.$route.path !== '/dailybriefing') {
        return;
      }
      console.log(data);
      this.overlay = false;
    });
    Event.$on('showProductDetails', () => {
      console.log('Show Product');
      this.overlay = true;
      this.productDetails = true;
    });
    Event.$on('tasks', (data) => {
      this.dailyBreif[2].message = data.events.length + ' PENDING';
    });
    Event.$on('invoices', (data) => {
      this.dailyBreif[3].message = data.events.length + ' INVOICES';
    });
    Event.$on('startbriefing', () => {
      console.log('Emitting');
      this.brefingIndex = 1;
      this.startBrefing();
      return;
    });
  },
};
</script>

<style scoped>
.about {
  padding: 20px;
}
.card {
  margin-left: 1rem;
  padding: 20px;
  width: 100%;
  height: 425px;
  cursor: pointer;
}
.row {
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
}
.flexbox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 350px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
  transition: all 1s ease-in-out;
}
.flexbox:hover {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  height: 425px;
  overflow: hidden;
  margin: 0 auto;
  padding: 0px;
  transition: scale(1.1);
}
.flexbox .board {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  max-width: 100%;
  background-color: transparent;
  padding: 0px;
}
.flexbox .board .card {
  padding: 5px;
  background: rgba(48, 64, 87, 0.3);
  outline-color: #42da91;
  color: #fff;
  min-width: 390px;
  max-width: 390px;
  cursor: pointer;
}
.ma-2 {
  width: 180px;
  transition: all 0.7s ease-in-out;
}
.ma-2:hover {
  width: 220px;
  transition: scale(1.1);
}
.html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #222;
  font-size: 0;
}
.svg {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: absolute;
}
.h1 {
  width: 100%;
  font-family: sans-serif;
  position: absolute;
  text-align: center;
  color: white;
  font-size: 18px;
  top: 40%;
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}
.h1 a {
  color: #48b1f4;
  text-decoration: none;
}
.path {
  stroke-linecap: square;
  stroke: white;
  stroke-width: 0.5px;
}
.space {
  height: 20px;
}
.theme-icons {
  background: #304057;
  color: #fff;
  size: 100px;
}
.theme-icons:hover {
  background: #304057;
  color: #fff;
}
.theme-bg-player {
  width: 800px;
}
.theme-bg-card {
  background: #0c161bad;
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 30px;
  border-radius: 10px;
  margin: 10px;
}
.theme-bg-card:hover {
  background: rgba(48, 64, 87, 0.7);
  outline-color: rgba(90, 128, 191, 1);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 10px rgba(120, 204, 226, 0.6), inset 0 0 15px rgba(120, 204, 226, 0.4), 0 6px 0 #000;
  color: #efe;
  outline-width: 3px;
  padding: 30px;

}
.theme-bg-card-active {
  background: rgba(30, 40, 54, 0.8);
  outline-color: rgba(66, 218, 145, 0.7);
  outline-style: solid;
  outline-width: 2px;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 25px rgba(90, 128, 191, 0.8), inset 0 0 20px rgba(90, 128, 191, 0.4), 0 10px 0 #000;
  color: #efe;
  text-align: center;
  margin: 10px;
  padding: 30px;
  animation-duration: 4s;
  transition: opacity 3s Elastic.easeOut;
  animation: shadow-pulse 2s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: 0 0 0 28px rgba(0, 0, 0, 0);
  }
}
@keyframes shadow-pulse-big {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 56px rgba(0, 0, 0, 0);
  }
}
.centerIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.theme-bg-card-2 {
  background: #0c161bc4;
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.4), inset 0 0 10px rgba(90, 128, 191, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  margin-block: auto;
  min-height: 100px; 
  width: 100px; 
  border-radius: 70px; 
  top: 380px;
  left: 570px;
}
.theme-bg-card-2:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: rgba(90, 128, 191, 1);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.6), inset 0 0 15px rgba(90, 128, 191, 0.4), 0 6px 0 #000;
  color: #efe;
  outline-width: 3px;
}
@media only screen and (max-width: 600px) {
.theme-bg-card-2 {
  background: #0c161bc4;
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.4), inset 0 0 10px rgba(90, 128, 191, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  min-height: 75px; 
  width: 75px; 
  border-radius: 70px; 
  top: 1180px;
  left: 30px;
}
.theme-bg-card-2:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: rgba(90, 128, 191, 1);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.6), inset 0 0 15px rgba(90, 128, 191, 0.4), 0 6px 0 #000;
  color: #efe;
  outline-width: 3px;
  padding: 22px;
}
}
/* @media only screen and (max-width: 1600px) {
.theme-bg-card-2 {
  background: #0c161bc4;
  outline-color: rgba(90, 129, 191, 0.205);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.4), inset 0 0 10px rgba(90, 128, 191, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  min-height: 70px; 
  width: 70px; 
  border-radius: 70px; 
  top: 1200px;
  left: 0px;
}
.theme-bg-card-2:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: rgba(90, 128, 191, 1);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.6), inset 0 0 15px rgba(90, 128, 191, 0.4), 0 6px 0 #000;
  color: #efe;
  outline-width: 3px;
  padding: 22px;
}
} */
.theme-bg-card-3 {
  background: rgba(48, 64, 87, 0.0);
  height: 150px;
}
.theme-bg-card-3:hover {
  padding: 25px;
}
.theme-bg-card-warning {
  background: rgba(255, 255, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}
.theme-bg-card-warning:hover {
  background: rgba(255, 255, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(0, 255, 0, 0.1), 0 2px 0 #000;
  color: #efe;
  outline: none;
}
.theme-bg-card-negative {
  background: rgba(255, 0, 0, 0.3);
  outline-color: #5a80bf;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}
.theme-bg-card-negative:hover {
  background: rgba(255, 0, 0, 0.5);
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #ff0000;
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.2), inset 0 0 5px rgba(255, 0, 0, 0.1), 0 2px 0 #000;
  color: #efe;
  outline: none;
}
.theme-bg-card-lg {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
}
.theme-bg-card-lg:hover {
  background: rgba(16, 22, 58, 0.5);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1000ms ease-out infinite alternate;
  border-color: #393;
  box-shadow: 0 0 7px rgba(0, 255, 0, 0.2), inset 0 0 7px rgba(0, 255, 0, 0.1), 0 2px 0 #000;
  outline: none;
}
@keyframes glow {
  0% {
    border-color: #393;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }
  100% {
    border-color: #78b59c;
    box-shadow: 0 0 8px rgba(0, 255, 0, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
.space1 {
  height: 35px;
}
.space2 {
  height: 1px;
}
.space3 {
  height: 1px;
}
.space4 {
  height: 1px;
}
.space5 {
  height: 150px;
}
.tabbar {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  & > li {
    margin: 0 11px;
    & > svg {
      width: 14px;
      height: 14px;
      display: block;
      fill: #2f3545;
      transition: opacity 0.3s ease;
    }
  }
  &.open {
    & > li {
      & > svg {
        opacity: 0.5;
      }
    }
  }
}
.Center & dribbble body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  background: #171c28;
  display: flex;
  justify-content: center;
  align-items: center;
  .dribbble {
    position: fixed;
    display: block;
    right: 20px;
    bottom: 20px;
    img {
      display: block;
      height: 28px;
    }
  }
}
.nav-title {
  color: #42da91;;
  text-align: center;
  font-size: 0.94rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
  padding-top: 10px;
  padding-bottom: 10px;
}
@media only screen and (max-width: 600px) {
  .nav-title {
    color: #42da91;;
    text-align: center;
    font-size: 0.70rem;
    font-weight: normal;
    font-family: Arimo, sans-serif;
    padding-top: 2px;
    padding-bottom: 2px;
  }
}
.text-color-2 {
  color: #42da91 !important;
}
.user-ui {
  background: rgba(48, 64, 87, 1);
  opacity: 1;
  color: #fff;
  padding: 20px;
}
.card-animate {
  animation-name: slideleft;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 2.75s;
  transition: opacity 1s easeIn;
}
.card-animate-out {
  animation-name: slideright;
  /* position: relative; */
  /* position-fromtop: 100px; */
  animation-duration: 1s;
  transition: opacity 1s easeOut;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: -40px;
    opacity: 0;
  }
  100% {
    left: 92px;
    top: -40px;
    opacity: 1;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}


.card-animate-2 {
  animation-name: slideExpandUp;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
  transition: opacity 1s Elastic.easeIn;
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.7s;
  -webkit-animation-duration: 2.7s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

.theme-bg-2 {
  background: rgba(48, 64, 87, 0.3);
  color: #fff;
}
.menu-icon {
  background: rgba(48, 64, 87, 0.3);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.menu-icon:hover {
  background: rgba(48, 64, 87, 0.5);
  padding: 30px;
  display: inline-block;
  margin-left: 50px;
  /* margin-top: 20px; */
  text-align: center;
  cursor: pointer;
}
.close-btn {
  position: absolute;
  right: 0px;
  margin-top: -60px;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}
.font {
  font-size: 1.2rem;
  font-weight: 500;
  font-family: Arimo, sans-serif;
  color: #fff;
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
}

.detail-card {
  width: 800px;
  height: 400px;
  background: #304057;
  opacity: 0.75;
  position: absolute;
}
.chart {
  color: #fff;
  background: #304057;
  background-size: 400% 400%;
  margin-left: 0px;
  padding: 25px;
  width: 404px;
  cursor: pointer;
  top: -60px;
  min-height: 10vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.icons {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 10px;
  text-align: center;
  color: #42da91 !important;
}
.icons:hover {
  font-size: 40px;
  color: #fff;
  margin-top: 0px;
  position: absolute;
  padding: 0px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff !important;
}

  .db-content {
    background: #304057;
    padding: 20px;
    min-height: 100%;
  }
  
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }
  
.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
.three-dot {
  margin-top: 10px;
  float: right;
  color: #fff;
}
.product-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.product-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.info-animate {
  animation-name: slideleft;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeIn;
}
.info-animate-out {
  animation-name: slideright;
  position: relative;
  position-fromtop: 100px;
  animation-duration: 1s;
  transition: opacity 1s Elastic.easeOut;
}
.product {
  width: 400px;
}
/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: 0px;
  }
  100% {
    left: 10px;
    top: 0px;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;
  animation-duration: 2.6s;
  -webkit-animation-duration: 2.6s;
  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;
  visibility: visible !important;
}
@keyframes slideExpandUp {
  0% {
    transform: translateY(100%) scaleX(0.94);
  }
  30% {
    transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    transform: translateY(2%) scaleX(0.96);
  }
  50% {
    transform: translateY(0%) scaleX(1);
  }
}
@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(100%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(2%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}
@media only screen and (max-width: 600px) {
  .product {
    width: 90%;
  }
  .card-margin {
    margin-top: 40px;
  }
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
  .menu-icon-2 {
    margin-left: 20px;
    color: #42da91 !important;
    margin-top: 20px;
  }
  .mb-margin {
    text-align: center;
  }
  .detail-card {
    width: 350px;
    height: 100%;
  }
  .callouts {
    padding: 100px;
    border: outline;
    background: #304057;
    opacity: 0.9;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
    outline-color: #5a80bf;
    outline-style: solid;
    animation: glow 1800ms ease-out infinite alternate;
    border-color: #5a80bf;
    box-shadow: 0 0 5px rgba(90, 128, 191, 0.2), inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
    outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2), inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
.button {
  border-radius: 50px;
  margin-block: 11px;
  width: 180px;
  opacity: 0.9;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  align: center;
  background: rgba(48, 64, 87, 0.7);
  outline-color: #42da91;
  color: #42da91;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5), 0 3px 3px rgba(0, 0, 0, 0.3);
  border: 1px solid #5e6570;
  padding: 10px 5px;
  animation: glow 1800ms ease-out infinite alternate;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 2px rgba(90, 128, 191, 0.2),
        inset 0 0 3px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
    100% {
      border-color: #11ece5;
      box-shadow: 0 0 6px rgba(90, 128, 191, 0.8),
        inset 0 0 8px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
@media only screen and (max-width: 600px) {
  
.button {
  border-radius: 15px;
  margin-block: 7px;
  width: 200px;
  opacity: 0.9;
  cursor: pointer;
  margin-left: 0px;
  margin-right: auto;
  left: 0px;
  right: 0px;
  align: center;
  background: rgba(48, 64, 87, 0.7);
  outline-color: #42da91;
  color: #42da91;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5), 0 3px 3px rgba(0, 0, 0, 0.3);
  border: 1px solid #5e6570;
  padding: 10px 5px;
  animation: glow 1800ms ease-out infinite alternate;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 2px rgba(90, 128, 191, 0.2),
        inset 0 0 3px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
    100% {
      border-color: #11ece5;
      box-shadow: 0 0 6px rgba(90, 128, 191, 0.8),
        inset 0 0 8px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
}
.bg-content {
    background: #131f25e7;
    padding: 0px;
    min-height: 87vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 1500px;
    }
    
@media only screen and (max-width: 600px) {
  .bg-content {
    background: #131f25e7;
    padding: 0px;
    min-height: 175vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    } 
  }
/* 
@media only screen and (max-width: 1600px) {
  .theme-bg-card-2 {
    background: #131f25e7;
    padding: 0px;
    min-height: 250vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    } 
  } */
.actions {
  top: 380px;
  left: 0px;
  right: 0px;
}
@media only screen and (max-width: 650px) { 
  .actions {
  top: 380px;
  left: 0px;
  right: 0px;
 }
}
@media only screen and (max-width: 900px) { 
  .actions {
  top: 380px;
  left: 0px;
  right: 0px;
 }
}
 .user-speach {
    position: absolute;
    top: -350px;
    font-size: 16px;
    width: 80%;
    left: 200px;
    right: 0px;
    border-radius: 15px;
    color: #fff;
    background: linear-gradient(-45deg, #0f1724, #151f2f, #19253a, #304057, #0f1724);
    background-size: 400% 400%;
    -webkit-animation: gradient 15s ease infinite;
    -animation: gradient 15s ease infinite;
  }
  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }
  .about {
    padding: 30px;
    background: rgba(48, 64, 87, 0.1);
    color: #111;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .callouts:hover {
    padding: 30px;
    border: outline;
    background: #304057;
    opacity: 1;
    color: #11ece5;
    cursor: pointer;
    position: relative;
    margin-left: 540px;
    margin-right: auto;
    left: 100px;
    right: 0px;
    align: center;
    text-align: center;
  }
}
</style>